export const swiperProps = {
  navigation: true,
  slidesPerView: 2,
  speed: 800,
  spaceBetween: 4,
  pagination: {
    clickable: true
  },
  breakpoints: {
    320: {
      slidesPerView: 1,
      slidesPerGroup: 1
    },
    576: {
      slidesPerView: 1,
      slidesPerGroup: 1
    },
    992: {
      slidesPerView: 2,
      slidesPerGroup: 2
    }
  }
}
